import { render, staticRenderFns } from "./ProductFive.vue?vue&type=template&id=c7dcd03a&"
import script from "./ProductFive.vue?vue&type=script&lang=js&"
export * from "./ProductFive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7dcd03a')) {
      api.createRecord('c7dcd03a', component.options)
    } else {
      api.reload('c7dcd03a', component.options)
    }
    module.hot.accept("./ProductFive.vue?vue&type=template&id=c7dcd03a&", function () {
      api.rerender('c7dcd03a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/products/ProductFive.vue"
export default component.exports